<template>
  <div>
    <vx-card title="운행지역" class="mb-4 text-center">
      <vs-textarea v-model="regions" class="mb-2" height="150px" />
      <vs-button @click="saveConfig('regions')">수정</vs-button>
    </vx-card>
    <vx-card title="지자체" class="mb-4 text-center">
      <vs-textarea v-model="municipalities" class="mb-2" height="150px" />
      <vs-button @click="saveConfig('municipalities')">수정</vs-button>
    </vx-card>
    <vx-card title="운행지자체" class="mb-4 text-center">
      <vs-textarea v-model="municipalities2" class="mb-2" />
      <vs-button @click="saveConfig('municipalities2')">수정</vs-button>
    </vx-card>
    <vx-card title="기사" class="mb-4 text-center">
      <vs-textarea v-model="engineers" class="mb-2" />
      <vs-button @click="saveConfig('engineers')">수정</vs-button>
    </vx-card>
    <vx-card title="리스트일정" class="mb-4 text-center">
      <vs-textarea v-model="listSchedules" class="mb-2" />
      <vs-button @click="saveConfig('listSchedules')">수정</vs-button>
    </vx-card>
    <vx-card title="잔여보조금" class="mb-4 text-center">
      <vs-textarea v-model="remainSubsidies" class="mb-2" />
      <vs-button @click="saveConfig('remainSubsidies')">수정</vs-button>
    </vx-card>
    <vx-card title="요청사유" class="mb-4 text-center">
      <vs-textarea v-model="requestReasons" class="mb-2" />
      <vs-button @click="saveConfig('requestReasons')">수정</vs-button>
    </vx-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      regions: '',
      municipalities: '',
      municipalities2: '',
      engineers: '',
      listSchedules: '',
      remainSubsidies: '',
      requestReasons: ''
    }
  },
  created () {
    // this.regions = this.$config.regions.join(',')
    this.regions = this.$root.regions.join(',')
    this.municipalities = this.$root.municipalities.join(',')
    this.municipalities2 = this.$root.municipalities2.join(',')
    this.engineers = this.$root.engineers.join(',')
    this.listSchedules = this.$root.listSchedules.join(',')
    this.remainSubsidies = this.$root.remainSubsidies.join(',')
    this.requestReasons = this.$root.requestReasons.join(',')
  },
  watch: {
    '$root.regions' (newValue) {
      this.regions = newValue.join(',')
    },
    '$root.municipalities' (newValue) {
      this.municipalities = newValue.join(',')
    },
    '$root.municipalities2' (newValue) {
      this.municipalities2 = newValue.join(',')
    },
    '$root.engineers' (newValue) {
      this.engineers = newValue.join(',')
    },
    '$root.listSchedules' (newValue) {
      this.listSchedules = newValue.join(',')
    },
    '$root.remainSubsidies' (newValue) {
      this.remainSubsidies = newValue.join(',')
    },
    '$root.requestReasons' (newValue) {
      this.requestReasons = newValue.join(',')
    }
  },
  methods: {
    saveConfig (fieldName) {
      this.$vs.loading()
      this.$db.doc('configs/installation').update({
        [`${fieldName}`]: this[fieldName]
      }).then(() => {
        this.$root[fieldName] = this[fieldName].split(',')
        this.$vs.loading.close()
      })
    }
  }
}
</script>